<template>
  <img
    :class="[
      $style['smart-image'],
      {[$style['smart-image--lazy']]: loading ==='lazy'}
    ]"
    :alt="alt"
    :width="width"
    :height="height"
    :style="{ opacity: loaded ? 1 : 0 }"
    :srcset="loadedSrcset"
    :src="loadedSrc"
    :loading="loading"
    @load="onLoad">
</template>
<script setup>
const emit = defineEmits(['load'])
const props = defineProps({
  src: {
    type: String,
    default: null
  },
  srcset: {
    type: String,
    default: null
  },
  alt: {
    type: [String, Boolean],
    default: null
  },
  width: {
    type: [String, Number],
    default: null
  },
  height: {
    type: [String, Number],
    default: null
  },
  loading: {
    type: String,
    default: 'lazy'
  }
})

const loadedSrc = props.loading === 'lazy' ? ref() : ref(props.src)
const loadedSrcset = props.loading === 'lazy' ? ref() : ref(props.srcset)
const loaded = ref(false)

const onLoad = () => {
  loaded.value = true
  emit('load', props.src)
}

onMounted(() => {
  loadedSrc.value = props.src
  loadedSrcset.value = props.srcset

  if (props.loading === 'auto') {
    loaded.value = true
  }
})
</script>

<style lang="scss" module>
.smart-image {
  width: 100%;
  opacity: 0;
  transition: opacity  var(--transition-time)  linear;
}
</style>
